import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import { GridColDef } from '@mui/x-data-grid-premium';
import { logService } from 'services/api/LogService';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { DeletedVersionsColumns } from 'components/common/enhanced/common-headers/versions_deleted';

export const DeleteVersions = () => {
  const translationPrefix = 'pages.versions.deleted';

  const { t } = useTranslation();

  const columns: GridColDef[] = DeletedVersionsColumns();

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}>
        <div className="mt-6">
          {/* Item list */}
          <div>
            <EnhancedDataGrid
              columns={columns}
              service={logService}
              refresh={null}
              disableDelete
              outerParams={{ action: 2 }}
            />
          </div>
        </div>
      </TenantPage>
    </>
  );
};

export default DeleteVersions;
